import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import Icon from "../../../../components/Icon";
import EmptyState from "../../../../components/EmptyState";
import Loading from "../../../../components/Loading";
import arrowLeft from "../../../../assets/icons/angle-left.svg";
import arrowRight from "../../../../assets/icons/angle-right.svg";
import Modal from "../../../../components/Modal";
import { useEffect, useMemo, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { getAllCalendars } from "../../../../store/actions/calendar";
import { CalendarDto } from "../../../../types/calendar.dto";
import { useLayout } from "../../../../provider/LayoutProvider";
import { Action, useActions } from "../../../../provider/ActionsProvider";
import { useNavigate } from "react-router";
import {
	Form,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableHeaderRow,
	TableRow,
	TableWrapper,
} from "./styles";
import Loader from "../../../../components/Spinner";
import judicial from "../../../../services/calendar";
import { toast } from "react-toastify";
import { hideModal, showModal } from "../../../../store/actions/modal";
// Setup the localizer by providing the moment (or globalize, or Luxon) Object
// to the correct localizer.
require("moment/locale/es.js");
const localizer = momentLocalizer(moment); // or globalizeLocalizer

interface ComponentProps {
	events: {
		hints: CalendarDto[];
		pagination;
	};
}
const Component = ({ events }: ComponentProps) => {
	const { setActions } = useActions();
	const { layout, setLayout } = useLayout();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [calendarEvent, setCalendarEvent] = useState<{ end; start; title }[]>(
		[]
	);
	const [importErrors, setImportErrors] = useState<string[]>([]);
	const [importSuccess, setImportSuccess] = useState<any[]>([]);
	const [isImporting, setIsImporting] = useState(false);

	const handleUploadFileButton = () => {
		document.getElementById("importar-eventos")?.click();
	};
	const handleImportEventsFromExcel = async (e) => {
		const selectedFile = e.target.files?.[0];
		if (!selectedFile) return;

		setIsImporting(true);
		dispatch(showModal("importResult"));

		try {
			const res = await judicial.importAgenda(selectedFile);

			const result =
				(res as any)?.error?.response?.data?.success?.result ||
				(res as any)?.response?.success?.result;

			const message =
				(res as any)?.error?.response?.data?.success?.message ||
				(res as any)?.response?.success?.message;

			const errorMessage = (res as any)?.error?.response?.data?.error?.message;

			setImportErrors(result?.errors || errorMessage || []);
			setImportSuccess(result?.createdSucces || result || []);

			if (message) {
				toast.info(message);
			}
		} catch (err) {
			console.error(err);
			dispatch(hideModal());
			toast.error("Error inesperado al importar la agenda");
		} finally {
			e.target.value = null;
			setIsImporting(false);
		}
	};

	const actions = useMemo(
		(): Action[] => [
			{
				component: "link",
				label: "Descargar Template",
				href: "https://adecco-arg.s3.us-east-1.amazonaws.com/Template+Agenda+Legales+import.xlsx ",
				options: {
					type: "outline",
					size: "lg",
					skin: "gray",
				},
			},
			{
				component: "button",
				label: "Cargar Eventos",
				onClick: () => {
					handleUploadFileButton();
				},
				options: {
					type: "outline",
					size: "lg",
					skin: "gray",
				},
			},
			{
				component: "link",
				label: "Nuevo evento",
				href: "/dashboard/agenda/new",
				options: {
					type: "filled",
					size: "lg",
					skin: "primary",
				},
			},
		],
		[]
	);

	const getElement = (event) => {
		navigate(`/dashboard/agenda/${event["item-id"]}`);
	};

	useEffect(() => {
		dispatch(hideModal());
		dispatch(getAllCalendars());
	}, []);

	useEffect(() => {
		if (!!events && !!events?.hints) {
			setCalendarEvent(
				events?.hints
					?.filter((event) => !!event["date-start"])
					.map((event) => {
						return {
							start: event["date-start"],
							end: event["date-end"] || event["date-start"],
							title: event.referncia || "Evento sin título",
							// ...((!event['date-end'] || event['date-end'] === event['date-start']) && {
							// }),
							allDay: true,
							data: event,
						};
					})
			);
		}

		setActions(actions);
		setLayout({ ...layout, fullFillContent: true, showBackButton: false });
	}, [events]);

	if (!events?.hints) {
		return <Loading />;
	}

	return (
		<>
			<Form
				className="p-absolute"
				style={{ height: "0px", width: "0px", overflow: "hidden" }}
			>
				<input
					id="importar-eventos"
					type="file"
					onChange={handleImportEventsFromExcel}
					multiple
					accept=".xls, .xlsx"
				/>
			</Form>
			<Calendar
				onSelectEvent={(event, _target) => getElement(event.data)}
				localizer={localizer}
				events={calendarEvent}
				startAccessor="start"
				endAccessor="end"
				scrollToTime={moment().set({ h: 10, m: 0 }).toDate()}
				messages={{
					date: "Fecha",
					time: "Hora",
					event: "Evento",
					allDay: "Todo el dia",
					week: "Semana",
					work_week: "Semana Laboral",
					day: "Día",
					month: "Mes",
					previous: <Icon icon={arrowLeft} size="20px" color="black" />,
					next: <Icon icon={arrowRight} size="20px" color="black" />,
					yesterday: "Ayer",
					tomorrow: "Mañana",
					today: "Hoy",
					agenda: "Agenda",

					noEventsInRange: <EmptyState />,
					showMore: function showMore(total) {
						return "+".concat(total, " ver más");
					},
				}}
			/>
			<Modal
				name="importResult"
				title="Importando Eventos"
				onClose={() => {
					setImportErrors([]);
					setImportSuccess([]);
					dispatch(getAllCalendars());
				}}
			>
				{importSuccess.length > 0 && (
					<>
						<h3>Agendas creadas correctamente</h3>
						<TableWrapper>
							<Table>
								<TableHead>
									<TableHeaderRow>
										<TableHeader>Título</TableHeader>
										<TableHeader>Estado</TableHeader>
									</TableHeaderRow>
								</TableHead>
								<TableBody>
									{importSuccess.map((item, index) => (
										<TableRow key={index}>
											<TableCell>{item.titulo}</TableCell>
											<TableCell>{item.type}</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</TableWrapper>
					</>
				)}

				{importErrors.length > 0 && (
					<>
						<h3>Errores encontrados</h3>
						<TableWrapper>
							<Table>
								<TableHead>
									<TableHeaderRow>
										<TableHeader>Detalle</TableHeader>
									</TableHeaderRow>
								</TableHead>
								<TableBody>
									{importErrors.map((err, index) => (
										<TableRow key={index}>
											<TableCell>{err}</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</TableWrapper>
					</>
				)}

				{importSuccess.length === 0 &&
					importErrors.length === 0 &&
					isImporting && (
						<div style={{ textAlign: "center" }}>
							<p>Cargando...</p>
							<Loader color="Primary" />
						</div>
					)}
				{importSuccess.length === 0 &&
					importErrors.length === 0 &&
					!isImporting && <p>No se recibieron resultados de la importación.</p>}
			</Modal>
		</>
	);
};

const state = ({ calendarStore }) => {
	const { data: events } = calendarStore.all;

	return {
		events,
	};
};

export default connect(state)(Component);
